import React from "react";
import { authenticate2, logoutAll } from "../../network/service";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { useLocation, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import Translate from "../MultiLanguage/Translate"

const LogoutAllModal = ({
  showId,
  appInfo,
  setLogoutModal,
  modalType,
  videoDetails,
  subscriptionCheckAndVideoPlay,
  handleClose

}) => {
  const user = useSelector((state) => state?.user?.value)
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const requestAppInfo = appInfo || {
    projectDetails: projectInfo,
    accessToken,
  };

  const tokenAuthenticate = async () => {
    try {
      const response = await authenticate2(requestAppInfo);
      if (response?.status === 200 && response?.data?.token) {
        dispatch(
          getAccessToken({
            accessToken: response?.data?.token,
          })
        );
        return true;
      }
    } catch (err) {
    }
    return false;
  };

  const logoutAllDevices = async () => {
    try {
      const logoutResponse = await logoutAll(requestAppInfo);

      if (logoutResponse?.status === 200) {
        dispatch(
          getUser({
            user: null,
          })
        );
        localStorage.removeItem("userId");
        const tokenRestored = await tokenAuthenticate();
        toast.success(<Translate textKey={'logged_out_successfully'}/>)
        //   , {
        //   position: "bottom-center",
        // });
        if (tokenRestored) {
          navigate("/login", { state: { showId, path: location?.pathname } });
        } else {
          window.location.assign("/login");
        }
      }
    } catch (err) {
    }
  };
  const logoutHandler = () => {
    if(handleClose){
      handleClose()
    }
    logoutAllDevices();
  };

  return (
    <div className="logoutAll">
      <Toaster position="bottom-center" />

      <div className="overlayModal"></div>
      {
        modalType?.type === "logoutAll" | modalType?.type === "videoWatchLimitExpired" &&
      <div className="closeIconContainer" onClick={() => setLogoutModal(false)}>
        <CloseIcon />
      </div>
      }
      <div className="contents">
        {modalType?.type === "redirect" ? (
          <>
            <h1 className="error"><Translate textKey={'session_expired_message'} /></h1>
            <p><Translate textKey={'redirecting_to_login_message'} /></p>
          </>
        ) : modalType?.type === "videoWatchLimitExpired"?(
          <>
            <h1 className="error"><Translate textKey={'free_limit_expired_message'} /></h1>
            {
              !user &&
              <p><Translate textKey={'login_subscribe_text'} /></p>
            }
            <div className="buttonContainer" onClick={() => setLogoutModal(false)}>
              <div className="background"></div>
              <button><Translate textKey={'ok'} /></button>
            </div>
          </>
        ) : (
          <>
            <h1>
              {
                modalType?.heading
              }

            </h1>
            <div className="buttonContainer">
              <button onClick={() => logoutHandler()}><Translate textKey={'yes'} /></button>
              {/* <button onClick={() => setLogoutModal(false)}><Translate textKey={'no'} /></button> */}
            </div>
          </>
        )}
        
      </div>
    </div>
  );
};

export default LogoutAllModal;
